<template>
  <div>
    <div
      role="heading"
      aria-level="2"
      class="pp-interaction-title"
      :key="pauseInteractionKey"
      :class="{
        'pp-rubric-section-text': interactionMeta.rubric,
        'white--text': interactionMeta.darkMode
      }"
      v-html="interaction.interactionText"
    ></div>
  </div>
</template>
<script>
/* global _ */
/* global dataLayer */
import EventBus from '@/buses/EventBus';
import {
  mapState,
  mapActions,
} from 'vuex';

// Mixins
import BarbriApp from '@/components/mixins/BarbriApp';

export default {
  name: 'interaction-pause-header',
  props: [
    'interactionId',
    'visible',
  ],
  data() {
    return {
      initial: false,
      pauseInteractionKey: 0,
    };
  },
  mixins: [
    BarbriApp,
  ],
  computed: {
    ...mapState('player', [
      'isLiveSession',
      'liveSessionTimeArray',
      'liveSessionUnixTime',
    ]),
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionCountdown() {
      if (this.isLiveSession) return Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime);
      return 0;
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
    sessionInteraction() {
      return _.find(this.liveSessionTimeArray, { 'interactionId': this.interaction.id });
    }
  },
  methods: {
    ...mapActions('interactions', [
      'submitAnswer'
    ]),
    initAnswer(isRetake) {
      this.interactionAttempt.responseText = ['pause_placeholder'];
    },
  },
  watch: {
    'visible'(newValue, oldValue) {
      if (
        this.visible
        && !this.interactionMeta.isInteractionAnswered
        && !this.isLiveSession
      ) {
        this.initAnswer();
        if (!this.interactionMeta.rubric)
          this.submitAnswer({
            interaction: this.interaction,
            interactionAttempt: this.interactionAttempt,
            interactionMeta: this.interactionMeta
          });
      }
      if (
        this.visible
        && (
          _.get(this.interaction, 'interactionText', '').includes('phet.colorado.edu')
          || _.get(this.interaction, 'interactionText', '').includes('physnav.org')
          || _.get(this.interaction, 'interactionText', '').includes('h5p.com')
        )
      ) {
        this.pauseInteractionKey += 1;
      }
      if (!newValue && oldValue) this.pauseInteractionKey += 1;
    },
    'interactionCountdown'(n) {
      /*
        Pause interactions cause the video to pause in a normal bulb.  They are also answered as soon as they are visible.
        In a liveSession we wait to submit and mark the interaction answered until the interactionDuration counts down
        Pauses do not have an interactionOffset - so once we submit, we trigger a play to continue session playback.
      */
      if (this.isLiveSession && n < 0 && this.visible && !this.interactionMeta.isInteractionAnswered) {
        this.initAnswer();
        if (!this.interactionMeta.rubric)
          this.submitAnswer({
            interaction: this.interaction,
            interactionAttempt: this.interactionAttempt,
            interactionMeta: this.interactionMeta
          }).then(() => {
            EventBus.$emit('requestAction', {
              key: 'play',
              setDesiredState: true
            });
          });
      }
    }
  },
  mounted() {
    // Downlaodable links are being stipped out due to discrepencies with BARBRI's mobile application.
    if (this.runningInBarbriApp) this.handleBarbriAppDownloadLinks();
  }
};
</script>

<style>
.q-header input[type='text'],
.q-header input[type='text']:not(.browser-default) {
  width: auto;
}
</style>
